import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    useTranslate,
    useNotify,
    useRedirect,
    SaveButton,
    Toolbar,
    DeleteButton,
    required,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import TranslateIcon from '@material-ui/icons/Translate';
import { CustomBreadcrumbs } from 'candy-commons-components';
import TextReveal from './TextReveal';
const CustomToolbar = ({ permissions = {}, ...props }) => {
    const isFormDisabledByPermissions =
        !permissions?.translation?.update || props?.invalid;
    return (
        <Toolbar {...props} classes={useStyles()}>
            <SaveButton disabled={isFormDisabledByPermissions} />

            {permissions[props.resource] &&
                permissions[props.resource].delete &&
                !isFormDisabledByPermissions && <DeleteButton undoable />}
        </Toolbar>
    );
};

const TranslationCreate = ({ permissions = {}, ...props }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const notify = useNotify();
    const redirect = useRedirect();

    const isFormDisabledByPermissions = !permissions?.translation?.update;

    const breadcrumbsData = [
        {
            text: translate('resources.translation.name'),
            url: 'translation',
            icon: <TranslateIcon />,
        },
        {
            text: translate('resources.translation.create.name'),
            url: '',
        },
    ];

    const onSuccess = ({ data }) => {
        if ('hasTextBeenSanitized' in data && data.hasTextBeenSanitized) {
            notify(
                `The translation key contained some invalid chars but has been sanitized and created, be careful next time!`
            );
        } else {
            notify(`Translation key created successfully`);
        }
        redirect('show', '/translation', data.id, data);
    };

    const validateCode = (value) => {
        const errors = [];
        if (value.length > 255) {
            errors.push('The Code field cannot exceed 255 characters / \n');
        }
        const dotCount = (value.match(/\./g) || []).length;
        if (dotCount !== 2) {
            errors.push(
                'Code requires a three-part hierarchy using dot separators / \n'
            );
        } else if (value.split('.').some((part) => part === '')) {
            errors.push('Each part of the hierarchy cannot be empty / \n');
        }
        if (!/^[A-Z0-9\._]+$/.test(value)) {
            errors.push(
                'Allowed characters: Uppercase letters, Numbers, Underscore, and Dot / \n'
            );
        }

        return errors.length > 0 ? errors.join('') : undefined;
    };

    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <TextReveal />
            <Create {...props} onSuccess={onSuccess}>
                <SimpleForm
                    toolbar={<CustomToolbar permissions={permissions} />}
                >
                    <TextInput
                        className={classes.containerFieldsFullWidth}
                        source="code"
                        validate={[required(), validateCode]}
                        disabled={isFormDisabledByPermissions}
                    />
                    <TextInput
                        className={classes.containerFieldsFullWidth}
                        fullWidth
                        multiline
                        source="lang_en"
                        validate={[required()]}
                        disabled={isFormDisabledByPermissions}
                    />
                </SimpleForm>
            </Create>
        </>
    );
};

const useStyles = makeStyles({
    containerFieldsFullWidth: {
        width: '100%  !important',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

export default TranslationCreate;
